import { getWeek } from 'date-fns';

import { MaxFormattingFunction, addDaysToNow, getDeliveryWeeks } from '.';
import { availableLocaleConfigs } from '../translations/localization';

const WEEK_LENGTH = 7;

export const formatDays: MaxFormattingFunction = ({ deliveryTime, translate }) => {
  return translate(
    deliveryTime.unit === 'business_day'
      ? 'widget.short_delivery_times.MAX_BUSINESS_DAYS'
      : 'widget.short_delivery_times.MAX_DAYS',
    {
      max: deliveryTime.max,
    }
  );
};

export const formatDate: MaxFormattingFunction = ({
  deliveryTime,
  translate,
  format,
  deliveryDaysAreTheSame,
}) => {
  const deliveryDate = addDaysToNow(deliveryTime.max);

  return translate(
    deliveryDaysAreTheSame
      ? 'widget.short_delivery_times.MAX_DATE_EXACT'
      : 'widget.short_delivery_times.MAX_DATE',
    {
      dayOfMonthMax: format(
        deliveryDate,
        translate('widget.short_delivery_times.DAY_OF_MONTH_FORMAT')
      ),
      MAX_MONTH_NUMBER: format(deliveryDate, 'MMM'),
    }
  );
};

export const formatWeekday: MaxFormattingFunction = ({
  deliveryTime,
  translate,
  format,
  deliveryDaysAreTheSame,
}) => {
  const deliveryDate = addDaysToNow(deliveryTime.max);

  if (deliveryTime.max < WEEK_LENGTH) {
    return translate(
      deliveryDaysAreTheSame
        ? 'widget.short_delivery_times.MAX_WEEKDAY_EXACT'
        : 'widget.short_delivery_times.MAX_WEEKDAY',
      {
        MAX_WEEKDAY_NUMBER: format(deliveryDate, 'EEEE'),
      }
    );
  } else {
    return translate(
      deliveryDaysAreTheSame
        ? 'widget.short_delivery_times.MAX_WEEKDAY_DATE_EXACT'
        : 'widget.short_delivery_times.MAX_WEEKDAY_DATE',
      {
        MAX_WEEKDAY_NUMBER: format(deliveryDate, 'EEE'),
        MAX_MONTH_NUMBER: format(deliveryDate, 'MMM'),
        dayOfMonthMax: format(
          deliveryDate,
          translate('widget.short_delivery_times.DAY_OF_MONTH_FORMAT')
        ),
      }
    );
  }
};

export const formatWeekdayDate: MaxFormattingFunction = ({
  deliveryTime,
  translate,
  format,
  deliveryDaysAreTheSame,
}) => {
  const deliveryDate = addDaysToNow(deliveryTime.max);

  return translate(
    deliveryDaysAreTheSame
      ? 'widget.short_delivery_times.MAX_WEEKDAY_DATE_EXACT'
      : 'widget.short_delivery_times.MAX_WEEKDAY_DATE',
    {
      MAX_WEEKDAY_NUMBER: format(deliveryDate, 'EEE'),
      MAX_MONTH_NUMBER: format(deliveryDate, 'MMM'),
      dayOfMonthMax: format(
        deliveryDate,
        translate('widget.short_delivery_times.DAY_OF_MONTH_FORMAT')
      ),
    }
  );
};

export const formatWeeks: MaxFormattingFunction = ({
  deliveryTime,
  translate,
  locale,
  deliveryWeeksAreTheSame,
}) => {
  const { deliveryWeekMax } = getDeliveryWeeks(deliveryTime, locale);

  return translate(
    deliveryWeeksAreTheSame
      ? 'widget.short_delivery_times.MAX_WEEKS_EXACT'
      : 'widget.short_delivery_times.MAX_WEEKS',
    {
      max: deliveryWeekMax,
    }
  );
};

export const formatWeekNumbers: MaxFormattingFunction = ({
  deliveryTime,
  translate,
  locale,
  deliveryWeeksAreTheSame,
}) => {
  const deliveryDate = addDaysToNow(deliveryTime.max);
  const localeConfig = availableLocaleConfigs[locale];

  return translate(
    deliveryWeeksAreTheSame
      ? 'widget.short_delivery_times.MAX_WEEK_NUMBER_EXACT'
      : 'widget.short_delivery_times.MAX_WEEK_NUMBER',
    {
      max: getWeek(deliveryDate, { locale: localeConfig }),
    }
  );
};
